<script context="module" lang="ts">
	import Section from '$lib/components/layout/Section.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { onDestroy } from 'svelte';
	import { gql } from 'graphql-request';

	export const config: SectionConfig = {
		collection: 'section_what_people_say',
		availableFor: ['pages'],
		query: gql`
            translations {
                    languages_code {
                        code
                    }
                    title
                }
			items {
				section_what_people_say_item_id {
                    image {
                        ...Media
                    }
					translations {
						languages_code {
							code
						}
						text
						name
						job_title
					}
				}
			}
    `
	};
	type Props = {
		title: string;
		items: any[];
	};
</script>

<script lang="ts">
	import Wysiwyg from '$lib/components/inputs/WYSIWYG.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import Slider from '$lib/components/util/Slider.svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
</script>

<Section class="section-testimonials" gapType="padding">
	<div slot="background" class="background" />
	<div class="banner">
		<div class="content">
			<div class="title-mobile">
				{data.title}
			</div>
			<Slider
				name="testimonial"
				type="single"
				slidesPerView={1}
				centeredSlides={false}
				navigation={true}
				pagination={false}
				arrowType="arrow"
			>
				{#each data.items as { section_what_people_say_item_id: item }}
					<div class="testimonial swiper-slide">
						<div class="media">
							<Media {...item.image} fit="cover" />
						</div>
						<div class="text-wrapper">
							<div class="title">
								{data.title}
							</div>
							<div class="wrapper">
								<div class="text"><Wysiwyg text={item.text} /></div>
								<div class="name">{item.name}, <span class="job-title">{item.job_title}</span></div>
							</div>
						</div>
					</div>
				{/each}
			</Slider>
		</div>
	</div>
</Section>

<style lang="scss">
	:global(.section-testimonials) {
		overflow: hidden;
		:global(.background) {
			background: color(yellow_02);
		}
	}

	:global(.section-testimonials .inner-section) {
		// max-width: 1800px !important;
		@include media(tablet) {
			max-width: 100%;
		}
	}

	.content {
		width: 100%;
		height: 100%;

		position: relative;

		:global(.navigation) {
			position: absolute;
			bottom: -15%;
			inset-inline-start: 0;
			transform: translateX(-45%);
			z-index: 10;
			padding-bottom: 0;
			@include media(tablet) {
				display: none;
			}
		}
		.swiper-slide {
			height: auto;
			min-height: 100%;
		}

		.testimonial {
			width: 100%;
			height: auto;
			justify-content: center;
			display: flex;
			grid-gap: v(content-gap-2xl);
			@include media(tablet) {
				justify-content: flex-start;
			}
			@media (max-width: 600px) {
				.title {
					display: none;
				}
				grid-gap: v(content-gap);
				flex-direction: column;
			}

			.media {
				overflow: hidden;
				width: 22%;
				:global(img) {
					aspect-ratio: 1/1;
				}
				@include media(tablet) {
					width: 30%;
				}
				@include media(phone) {
					width: 100%;
				}
			}
			.title {
				@include font(h6);
				margin-bottom: v(content-gap-xl);
			}

			.text {
				@include font(text-xl);
				margin-bottom: v(content-padding-xs);
				max-width: 400px;
				@include media(phone) {
					max-width: 100%;
				}
			}
			.job-title {
				@include font(info-sm);
				text-transform: none;
			}
			.wrapper {
				display: flex;
				flex-direction: column;
				justify-content: center;
				// height: 100%;
				// @include media(phone) {
				// 	height: auto;
				// }
			}
			.text-wrapper {
				display: flex;
				flex-direction: column;
			}

			.name {
				@include font(info);
				text-transform: uppercase;
			}
		}
	}
	.title-mobile {
		display: none;
		@media (max-width: 600px) {
			display: flex;
			@include font(h6);
			margin-bottom: v(content-gap);
		}
	}
</style>
